import { lazy } from 'react';

export const CurrentAsset = lazy(() => import('./CurrentAssetWrapper.component'));
